import { render, staticRenderFns } from "./WooOrders.vue?vue&type=template&id=d4632ec6&scoped=true&"
import script from "./WooOrders.vue?vue&type=script&lang=js&"
export * from "./WooOrders.vue?vue&type=script&lang=js&"
import style0 from "./WooOrders.vue?vue&type=style&index=0&id=d4632ec6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4632ec6",
  null
  
)

export default component.exports